/** 聊天背景预设（纯 CSS），选择结果存 localStorage */
export const chatBgStorageKey = 'im-chat-bg';
export const chatBgDefault = 'default';

export const chatBgPresets = [
	{ id: 'default', nameKey: 'userConfig.chatBgDefault' },
	{ id: 'sky', nameKey: 'userConfig.chatBgSky' },
	{ id: 'lavender', nameKey: 'userConfig.chatBgLavender' },
	{ id: 'warm', nameKey: 'userConfig.chatBgWarm' },
	{ id: 'dots', nameKey: 'userConfig.chatBgDots' },
	{ id: 'grid', nameKey: 'userConfig.chatBgGrid' },
	{ id: 'stripe', nameKey: 'userConfig.chatBgStripe' },
	{ id: 'diamond', nameKey: 'userConfig.chatBgDiamond' }
];

const presetIds = new Set(chatBgPresets.map((p) => p.id));

export function getChatBgId() {
	const id = localStorage.getItem(chatBgStorageKey);
	return presetIds.has(id) ? id : chatBgDefault;
}

export function setChatBgId(id) {
	const next = presetIds.has(id) ? id : chatBgDefault;
	localStorage.setItem(chatBgStorageKey, next);
	return next;
}
